import React from 'react'
import { Table } from 'react-bootstrap'
import DatePicker from 'react-multi-date-picker'
import Toolbar from 'react-multi-date-picker/plugins/toolbar'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCalendar, faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons'
import Pagination from '../../layout/Pagination'
import ReactFilter from '../../components/inputs/ReactFilterList'
import LoadingScreen from '../../components/LoadingScreen'
import GoogleIcon from '../../icon/GoogleIcon'
import { UI_COLOR_ACCENT_ORANGE_ALT, UI_COLOR_PRIMARY } from '../../constants/uiColors'
import { formatMoney } from '../../helpers/utils'

const QuoteIndexView = ({
  data,
  filters,
  filterVersion,
  isFetching,
  pagination,
  handlePaginationClick,
  updateAllSelectedOptions,
  handleDateFilter,
  selectedDates,
  searchInput,
  handleSearch,
  handleEnterSearch,
  resetFilters,
  isAnyFilterSelected
}) => {
  const showQuote = (event, quoteId) => {
    event.preventDefault()
    window.open(`/cotizaciones/${quoteId}`, '_blank')
  }

  const getFormattedDate = (createdDate) => {
    if (!createdDate) return '-'
    return new Date(createdDate).toLocaleString()
  }

  if (isFetching) return <LoadingScreen text="Cargando..." />

  return (
    <>
      <div className="index-header detailed-container">
        <h2 className="mb-20">Cotizaciones</h2>
      </div>
      <div className="index-table">
        <div className="show-area">
          <h4 className="text-sub-title">Filtrar cotizaciones por:</h4>
          <div className="filters-search-container mb-10">
            <GoogleIcon className="filter-icon-poc oc-icon-primary" name="page_info" size={22} />
            <div className="filters-container">
              {filters.map((filter, index) => (
                <div key={`quote-filter-${index}`} className="mr-10">
                  <ReactFilter
                    className="mr-10"
                    title={filter.key}
                    identifier={filter.key}
                    options={filter.value}
                    disabled={!filter.value?.length}
                    resetWatcher={filterVersion}
                    onSelectionChange={updateAllSelectedOptions}
                  />
                </div>
              ))}
              <DatePicker
                range
                rangeHover
                dateSeparator=" - "
                format="DD MMM"
                weekStartDayIndex={1}
                highlightToday={false}
                numberOfMonths={2}
                onChange={handleDateFilter}
                value={selectedDates}
                plugins={[
                  <Toolbar
                    key="datepicker-toolbar"
                    position="bottom"
                    names={{ deselect: 'Deseleccionar' }}
                    sort={['deselect']}
                  />
                ]}
                render={(value, openCalendar) => (
                  <div className="mr-10">
                    <div className="react-filter-box filter-input-width-datepicker">
                      <div
                        title="Rango de fechas"
                        onClick={openCalendar}
                        className="react-filter-box-clickable-zone"
                      >
                        <div className="react-filter-titles">
                          <div className="react-filter-title-text">
                            <div className="filter-title-overflow">
                              {value?.length > 0
                                ? Array.isArray(value)
                                  ? value.join(' - ')
                                  : value
                                : 'RANGO DE FECHAS'}
                            </div>
                          </div>
                          <FontAwesomeIcon
                            className="react-filter-title-chevron"
                            style={{ color: value?.length > 0 ? UI_COLOR_ACCENT_ORANGE_ALT : UI_COLOR_PRIMARY }}
                            icon={faCalendar}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              />
            </div>
            <div className="search-input-containter">
              <input
                value={searchInput}
                onChange={handleSearch}
                onKeyDown={handleEnterSearch}
                className="round-search-input"
                style={{ fontSize: 12 }}
                placeholder="Buscar cotizaciones por # o nombre de cliente"
              />
              {searchInput === '' && (
                <FontAwesomeIcon icon={faMagnifyingGlass} className="search-icon" />
              )}
              {searchInput && (
                <div title="Limpiar texto" onClick={resetFilters} className="round-search-input-x">
                  X
                </div>
              )}
            </div>
          </div>
          <div className="mb-20">
            {isAnyFilterSelected && (
              <a onClick={resetFilters} className="reset-filter cursor-pointer mb-20">
                Restablecer filtros aplicados
              </a>
            )}
          </div>
          <Table hover responsive>
            <thead className="table-header-gray-mui">
              <tr>
                <th style={{ verticalAlign: 'middle', padding: '10px 25px', width: '12%' }}>
                  FECHA Y HORA
                </th>
                <th style={{ verticalAlign: 'middle', width: '13%' }}># DE COTIZACIÓN</th>
                <th style={{ verticalAlign: 'middle', width: '15%' }}>CÓDIGO DE CLIENTE</th>
                <th style={{ verticalAlign: 'middle', width: '22%' }}>NOMBRE DE CLIENTE</th>
                <th style={{ verticalAlign: 'middle', width: '18%' }}>CREADO POR</th>
                <th style={{ verticalAlign: 'middle', width: '12%', textAlign: 'right' }}>TOTAL COTIZACIÓN</th>
                <th style={{ verticalAlign: 'middle' }}>ESTADO</th>
              </tr>
            </thead>
            <tbody>
              {data && data.length > 0 ? (
                data.map((model) => (
                  <tr className="cursor-pointer" key={model.uid}>
                    <td className="td-text-limited td-text-limited-space" onClick={(e) => showQuote(e, model.uid)}>
                      {getFormattedDate(model.date_of_order)}
                    </td>
                    <td className="td-text-limited" onClick={(e) => showQuote(e, model.uid)}>
                      {model.uid}
                    </td>
                    <td className="td-text-limited" onClick={(e) => showQuote(e, model.uid)}>
                      {model.client_uid}
                    </td>
                    <td className="td-text-limited" onClick={(e) => showQuote(e, model.uid)}>
                      {model.client_name}
                    </td>
                    <td className="td-text-limited" onClick={(e) => showQuote(e, model.uid)}>
                      {model.user_uid} - {model.user_full_name}
                    </td>
                    <td className="td-text-limited" style={{ textAlign: 'right' }} onClick={(e) => showQuote(e, model.uid)}>
                      {formatMoney(Number(model.total || 0))}
                    </td>
                    <td onClick={(e) => showQuote(e, model.uid)}>
                      <div className="td-order-status">
                        <div className="order-status sent-style">ENVIADO</div>
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="7" className="td-text-limited td-text-limited-space">
                    No hay resultados
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
      </div>
      {pagination.total_pages > 1 ? (
        <nav className="index-table">
          <div onClick={handlePaginationClick}>
            <Pagination current_page={pagination.current_page} total_pages={pagination.total_pages} />
          </div>
        </nav>
      ) : null}
    </>
  )
}

export default QuoteIndexView
